import { useState } from 'react';

interface Props {
  phrase: string;
  mode: 'show_first_time' | 'show_again';
  onClose: () => void;
}

export default function RecoveryPhraseModal({ phrase, mode, onClose }: Props) {
  const words = phrase.split(/\s+/);
  const [confirmed, setConfirmed] = useState(false);
  const [revealed, setRevealed] = useState(mode === 'show_again');

  return (
    <div className="modal-backdrop">
      <div
        className="modal"
        style={{
          maxWidth: 520,
          maxHeight: 'calc(100vh - 32px)',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
          boxSizing: 'border-box',
        }}
      >
        <h2 style={{ margin: 0 }}>🔑 Tu clave de recuperación</h2>
        <p style={{ margin: 0, fontSize: '0.9rem', lineHeight: 1.45, opacity: 0.9 }}>
          Estas <b>24 palabras</b> son la única forma de recuperar tu cuenta y el historial
          si olvidas la contraseña o pierdes el dispositivo. <b>Apúntalas en papel y
          guárdalas en un lugar seguro.</b> Nadie en Syphrax puede recuperarlas por ti.
        </p>

        {!revealed ? (
          <button className="primary" style={{ width: '100%' }} onClick={() => setRevealed(true)}>
            Mostrar palabras
          </button>
        ) : (
          <>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                gap: 6,
                padding: 12,
                background: 'rgba(255,255,255,0.04)',
                borderRadius: 8,
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                fontSize: '0.88rem',
                boxSizing: 'border-box',
              }}
            >
              {words.map((w, i) => (
                <div key={i} style={{ display: 'flex', gap: 6, minWidth: 0 }}>
                  <span style={{ opacity: 0.5, minWidth: 22, textAlign: 'right', flexShrink: 0 }}>{i + 1}.</span>
                  <span style={{ overflowWrap: 'anywhere' }}>{w}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                onClick={() => navigator.clipboard?.writeText(phrase).catch(() => {})}
                className="secondary"
                style={{ flex: 1, minWidth: 0 }}
              >
                Copiar
              </button>
              <button
                onClick={() => {
                  const blob = new Blob([phrase], { type: 'text/plain' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url; a.download = 'syphrax-recovery-phrase.txt';
                  a.click();
                  URL.revokeObjectURL(url);
                }}
                className="secondary"
                style={{ flex: 1, minWidth: 0 }}
              >
                Descargar
              </button>
            </div>
          </>
        )}

        {mode === 'show_first_time' && revealed && (
          <label
            style={{
              display: 'block',
              cursor: 'pointer',
              padding: '8px 0',
              fontSize: '0.9rem',
              lineHeight: 1.4,
            }}
          >
            <input
              type="checkbox"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              style={{
                width: 18,
                height: 18,
                marginRight: 10,
                verticalAlign: 'middle',
              }}
            />
            <span style={{ verticalAlign: 'middle' }}>
              He guardado mi clave de recuperación en un lugar seguro
            </span>
          </label>
        )}

        <button
          className="primary"
          style={{ width: '100%' }}
          disabled={mode === 'show_first_time' && !confirmed}
          onClick={onClose}
        >
          {mode === 'show_first_time' ? 'He terminado' : 'Cerrar'}
        </button>
      </div>
    </div>
  );
}
